import { deleteOrdersId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { orderKeys } from "Order/Api/orderKeys";
import { OrderPaths } from "Order/Routes/Routing";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { toast } from "sonner";

const orderMutationsResource = Resources.base.order.mutations;

export const useArchiveOrder = () => {
	const { t } = useResource();
	const queryClient = useQueryClient();
	const navigate = useNavigate();

	return useMutation({
		mutationFn: processResponse((orderId: number) => deleteOrdersId(orderId)),
		onError: (error) => {
			console.error(`${t(orderMutationsResource.orderArchiveError)}:`, error);
		},
		onSuccess: () => {
			toast.success(t(orderMutationsResource.orderArchiveSuccess));
			queryClient.invalidateQueries({ queryKey: orderKeys.listAll });
			navigate(OrderPaths.Index.route);
		},
	});
};
